import React, { useEffect, useState, useCallback } from 'react'
import { useLocation, useParams } from 'umi'
import { matchRouteUrl, timeZoneTransformForShow } from '@/pages/dashboard/utils/utils'

// 缓存数据避免重复请求
let cacheData = {
  country: null,
  zone: null
}

// let isFetch = false

const useSelectorData = ({gameCode, filterRef}: any = {}) => {
  const { timezonetype: type } = (useParams() ?? {}) as any
  const [selectorData, setSelectorData] = useState(cacheData?.[type])
  const [selectDataLoading,setSelectorDataLoading] = useState<boolean>(false)
  const location = useLocation()
  useEffect(() => {
    const {
      filterVisibleList,
      defaultInputList,
      getFilterListData
    } = filterRef ?? {}
    if (
        !filterVisibleList
        || !defaultInputList
        || !getFilterListData
        || !gameCode
        || cacheData[location.pathname] != null
      ) return
    
    const target = filterVisibleList?.page_selector?.find((item) => matchRouteUrl(location.pathname,item.path))?.filters?.map?.(item => ({...item, type: item?.key}))
    const backendDefaultInput = filterVisibleList?.default_selector?.[0]?.filters?.map?.(item => ({...item, type: item?.key}))

    const visibleList = (() => {
      if (target?.length > 0) return target
      if (backendDefaultInput?.length > 0) return backendDefaultInput
      return defaultInputList
    })()

    const selectListMap = {
      zone: ['zone'],
      region: ['country', 'area'],
      channel: ['channel'],
      system: ['os'],
      lang: ['lang'],
    }
    let selector_list = []
    visibleList?.forEach((item) => {
      if (item.type in selectListMap) {
        selector_list = selector_list.concat(selectListMap[item.type])
      }
    })

    const params = {
      game_code: gameCode,
      selector_list
    }

    if (typeof filterRef?.getFilterListData === 'function') {
      setSelectorDataLoading(true)
      getFilterListData(params)
      .then((res) => {
        const filterRes = {
          ...(res ?? {}),
          countryList: res?.countryList?.map(countryItem => ({
            ...countryItem,
            deviation: timeZoneTransformForShow(countryItem?.deviation)
          })),
          regionList: res?.regionList?.map(region => ({
            ...region,
            country: region?.country?.map(countryItem => ({
              ...countryItem,
              deviation: timeZoneTransformForShow(countryItem?.deviation)
            }))
          })),
          zoneList: res?.zoneList?.map(zone => ({
            ...(zone ?? {}),
            deviation: timeZoneTransformForShow(zone?.deviation)
          })),
          latestDate: res?.latestDate
        }
        // 更新状态并缓存数据
        cacheData[location.pathname] = filterRes
        setSelectorData(filterRes)
        setSelectorDataLoading(false)
      }).catch(e=>{
        console.log(e)
      })
    }
  }, [location.pathname, typeof filterRef?.getFilterListData])

  return {
    selectorData: selectorData ?? cacheData?.[location.pathname] ?? null,
    type,
    selectDataLoading
  }
}

export default useSelectorData
